module.exports = __webpack_public_path__ + "static/media/James Field.5168ebb8.png";